import { render, staticRenderFns } from "./MedicalAlertDownload.vue?vue&type=template&id=32453b0a&scoped=true&"
import script from "./MedicalAlertDownload.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32453b0a",
  null
  
)

export default component.exports